import type { PageSearchMatch } from "~/services/aiOrchestrator";

const MAX_PAGE_SUGGESTIONS = 3;

const pickJevPageSuggestions = (
	matches: readonly PageSearchMatch[],
	shownPageIds: readonly string[]
): PageSearchMatch[] => {
	const offeredTier = matches.some((match) => match.tier === "SUGGESTED") ? "SUGGESTED" : "CHECK";
	const seenPageIds = new Set(shownPageIds);
	return matches
		.filter((match) => {
			if (match.tier !== offeredTier || seenPageIds.has(match.pageId)) return false;
			seenPageIds.add(match.pageId);
			return true;
		})
		.slice(0, MAX_PAGE_SUGGESTIONS);
};

export default pickJevPageSuggestions;
